<template>
  <vs-row>
    <vs-col>
      <div v-if="!loadingTables">
        <div v-if="!venueSection">
          <p class="text-gray text-sm">
            No available tables until section has been selected
          </p>
        </div>
        <div v-if="venueSection && (!scoredTables || scoredTables.length == 0)">
          <p class="text-gray text-sm">
            No available tables for this date, time and section
          </p>
        </div>
        <div v-if="venueSection && scoredTables && scoredTables.length > 0">
          <vs-row class="btn-group select-table-btn-group">
            <vs-button
              class="select-table-btn-name-text"
              @click="
                $refs.popupSelectTable.show(
                  venueDetails,
                  venueSetup,
                  venueSection,
                  scoredTables
                )
              "
              type="border"
              color="primary"
              :disabled="disableComponent"
            >
              <span>Select new table </span>
            </vs-button>
            <vs-button
              type="border"
              color="primary"
              class="select-table-icon-button"
              @click="
                $refs.popupSelectTable.show(
                  venueDetails,
                  venueSetup,
                  venueSection,
                  scoredTables
                )
              "
              :disabled="disableComponent"
            >
              <feather-icon
                icon="SearchIcon"
                svgClasses="h-4 w-4 "
              ></feather-icon>
            </vs-button>
          </vs-row>
        </div>
      </div>
      <div v-if="loadingTables">
        <span class="flex h-4 w-4 mt-2">
          <span
            class="
              animate-ping
              absolute
              inline-flex
              h-4
              w-4
              rounded-full
              bg-primary
              opacity-75
            "
          ></span>
          <span
            class="relative inline-flex rounded-full h-4 w-4 bg-primary"
          ></span>
        </span>
      </div>
    </vs-col>

    <popup-select-table
      v-if="!disableComponent"
      ref="popupSelectTable"
      @table-selected="handleTableSelected($event)"
    />
  </vs-row>
</template>

<script>
import PopupSelectTable from "./PopupSelectTable.vue";

export default {
  components: {
    PopupSelectTable,
  },
  props: {
    venueDetails: Object,
    venueSetup: Object,
    venueSection: Object,
    //venueTableId: Object,
    scoredTables: Array,
    loadingTables: Boolean,
    disableComponent: Boolean,
  },
  data() {
    return {
      //selectedScoredTable: undefined,
    };
  },
  async mounted() {},
  computed: {},
  watch: {
    // venueTableId(val, old) {
    //   this.setSelectedScoredTable();
    // },
    // scoredTables() {
    //   this.setSelectedScoredTable();
    // },
  },
  methods: {
    handleTableSelected(scoredTable) {
      //this.selectedScoredTable = scoredTable;
      this.$emit("scored-table-selected", scoredTable);
    },
    // setSelectedScoredTable() {
    //   if (this.scoredTables && this.venueTableId) {
    //     this.selectedScoredTable = this.scoredTables.find(
    //       (act) => act.table.venueTableId.id === this.venueTableId.id
    //     );
    //   }
    //   else{
    //     this.selectedScoredTable = null;
    //   }
    // },
  },
};
</script>

<style lang="scss" scoped>
.select-table-btn-group::v-deep {
  button.vs-button {
    border: 1px solid rgba(0, 0, 0, 0.2);
    background: white !important;
    padding: 0.7rem !important;

    &.select-table-btn-name-text {
      width: calc(100% - 45px);
      border-radius: 5px 0 0 5px;
      .vs-button-text {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        width: 100%;
        vertical-align: bottom;
      }
    }

    &.select-table-icon-button {
      border-radius: 0 5px 5px 0;
      .vs-button-text {
        line-height: 1;
        vertical-align: bottom;
      }
    }
  }

  .select-table-btn-name-text {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>
